export function BackToTop(event){
	let wrapper = document.getElementsByClassName('mainWrapper')[0];
	if(wrapper.scrollTop > 0){
		wrapper.scrollBy(0, -50);
		setTimeout(BackToTop, 1);
	}
}
